import { setContext } from '@apollo/client/link/context'

export function createAuthLink(
  authToken?: string,
  tokenFunction?: () => Promise<string | undefined>,
) {
  return setContext(async (_, { headers }) => {
    const token =
      authToken || (tokenFunction && (await tokenFunction())) || null
    return {
      headers: {
        ...headers,
        ...(token ? { authorization: `Bearer ${token}` } : {}),
      },
    }
  })
}
